/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import Loading from 'modules/common/components/Loading';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';
import EhelpChartComponent from '../components/EhelpChartComponent';
import VaccineRegistrationGraph from '../components/VaccineRegistrationGraph';

const renderLegends = (dt) =>
  dt.map((x) => {
    return (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    );
  });

function EhelpDashboardContainer({
  graphStats,
  getGraphStats,
  getVaccineRegistrationGraph,
  vaccineRegistrationData,
}) {
  const [isLoading, setIsLoading] = useState(true);

  const handleOnSubmit = (data) => {
    getGraphStats(data);
  };

  const handleOnSubmitVaccine = (data) => {
    getVaccineRegistrationGraph(data);
  };

  useEffect(() => {
    getGraphStats();
    getVaccineRegistrationGraph();
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <>
      <div className="dashboard-card">
        <div className="row mb-3">
          <div className="col-12">
            <div className="main-text">Statistics</div>
          </div>
          <div className="col-12">
            <SelectDateFilter onSubmit={handleOnSubmit} />
          </div>
          <div className="col-12">
            <EhelpChartComponent
              chartData={graphStats}
            />
          </div>
          <div className="legends-wrapper area px-3 w-100">
            <div
              className="render-chart-legends"
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {renderLegends(c.LEGENDS)}
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard-card">
        <div className="row mb-3">
          <div className="col-12">
            <div className="main-text">Covid-19 Vaccine</div>
          </div>
          <div className="col-12">
            <SelectDateFilter onSubmit={handleOnSubmitVaccine} />
          </div>
          <div className="col-12">
            <VaccineRegistrationGraph
              chartData={vaccineRegistrationData}
            />
          </div>
          <div className="legends-wrapper area px-3 w-100">
            <div
              className="render-chart-legends"
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {renderLegends(c.COVID_19_LEGENDS)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

EhelpDashboardContainer.propTypes = {
  graphStats: PropTypes.instanceOf(Object).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
  vaccineRegistrationData: PropTypes.instanceOf(Object).isRequired,
  getVaccineRegistrationGraph: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
  vaccineRegistrationData: _.get(api, `${c.GET_VACCINE_REGISTRATION_GRAPH}.list`) || [],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(EhelpDashboardContainer);
